<template>

    <video-player ref="videoPlayer"
                  :options="playerOptions"
                  class="player-fit vjs-big-play-centered vjs-16-9"
                  @play="onPlayerPlay($event)"
                  @ready="onPlayerReady($event)"
                  disablepictureinpicture>
    </video-player>

</template>

<script>

    import { videoPlayer } from 'vue-videojs7'

    export default {

        components: {
            videoPlayer
        },

        props: [
            'currentlocale',
            'herocontent'
        ],

        data () {

            return {

                ENV_CloudFront_Legacy_DNS_Name: process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME,
                ENV_CloudFront_DNS_Name: process.env.MIX_CLOUDFRONT_DNSNAME,
                ENV_Thumbnail_Key: process.env.MIX_BASE_THUMBNAIL_KEY,
                heroContent: JSON.parse(this.herocontent),

                playCountUpdated: false

            }
        },

        computed: {

            mediaSrc() {
                console.log('INCOMING HERO CONTENT:' + this.heroContent);

                if(this.heroContent.legacy) { console.log('LEGACY is TRUE') } else { console.log('LEGACY is FALSE') }

                if(!this.heroContent.legacy) {
                    console.log('HEROCONTENT: ' + this.heroContent.storage_url);
                    console.log('PASSING TO PLAYER: ' + this.ENV_CloudFront_DNS_Name + this.heroContent.storage_url);
                    return this.ENV_CloudFront_DNS_Name + this.heroContent.storage_url;
                } else {
                    console.log('PASSING TO PLAYER: ' + this.ENV_CloudFront_Legacy_DNS_Name + this.heroContent.storage_url);
                    return this.ENV_CloudFront_Legacy_DNS_Name + this.heroContent.storage_url;
                }
            },

            player () {
                return this.$refs.videoPlayer.player
            },

            src() {
                this.mediaSrc = this.ENV_CloudFront_DNS_Name + this.heroContent.storage_url
            },

            playerOptions() {

                if(!this.heroContent.legacy) {
                    return {
                        autoplay: false,
                        controls: true,
                        controlBar: {
                            timeDivider: false,
                            durationDisplay: false,
                        },
                        fluid: true,
                        /*poster: process.env.MIX_CLOUDFRONT_DNSNAME + this.$root.shared.hero_content.thumbnail_url*/
                        poster: this.ENV_CloudFront_DNS_Name + this.heroContent.filename + '/' + this.ENV_Thumbnail_Key + this.heroContent.hero_thumbnail + '.jpg'
                    }
                } else {
                    return {
                        autoplay: false,
                        controls: true,
                        controlBar: {
                            timeDivider: false,
                            durationDisplay: false,
                        },
                        fluid: true,
                        /*poster: process.env.MIX_CLOUDFRONT_DNSNAME + this.heroContent.thumbnail_url*/
                    }
                }
            },

        },


        methods: {

            onPlayerPlay (player) {

                if(!this.playCountUpdated) {

                    axios.get('/' + this.currentlocale + '/content/stats/add-play/' + this.heroContent.id)
                        .then(response => {
                            this.playCountUpdated = true;
                            this.$root.shared.contentPlays = JSON.stringify(response.data);
                        })
                        .catch(error => {
                            console.log('There was an error updating the Play Count for this Content! ERROR: ' + error);
                        });

                    console.log('Updated the Content play count!');

                } else {
                    console.log('Play Count for this instance has already been updated, so skipping.');
                }
            },

            onPlayerReady (player) {
                console.log('player ready!', player)
                console.log('Media Duration: ', player.duration())
                // this.player.play()
            },

            playVideo: function (source) {

                if(this.heroContent.legacy) {
                    const video = {
                        withCredentials: false,
                        type: 'video/mp4',
                        src: source
                    }

                    this.player.src(video);
                    this.player.controlBar.pictureInPictureToggle.dispose();

                } else {
                    const video = {
                        withCredentials: false,
                        type: 'application/x-mpegurl',
                        src: source,
                    }

                    this.player.src(video);
                    this.player.controlBar.pictureInPictureToggle.dispose();
                }
            }
        },

        mounted () {
            this.playVideo(this.mediaSrc)
        }

    }

</script>

<style scoped>

    .video-js .vjs-fluid {
        width: auto;
        height: auto;
        max-height: 395px !important;
    }

    .player {
        /* position: absolute !important; */
        width: 100%;
        height: 60%;
    }

    .vjs-custom-skin {
        height: 60% !important;
    }

    .vjs-custom-skin /deep/ .video-js {
        height: 60%;
    }

    .player-fit {
        position: relative !important;
        width: 100% !important;
        height: auto !important;
    }

</style>
